import type { ModulePermissionShape } from "@/types/permissions";

export const contestAgreementsPermissionKeys = [
  "contest_agreements_read_basic",
  "contest_agreements_read_full",
] as const;

export type ContestAgreementsPermissions = ModulePermissionShape<
  typeof contestAgreementsPermissionKeys
>;
